import { useCallback, useRef } from "react";
import { type ThreeEvent } from "@react-three/fiber";

import { useChatPanelStore } from "@/store/chatPanelStore";
import { useEngineStore } from "@/store/useEngineStore";

export function useRTSControls() {
  const pokeAudioRef = useRef<HTMLAudioElement | null>(null);
  if (typeof window !== "undefined" && !pokeAudioRef.current) {
    pokeAudioRef.current = new Audio("/assets/audio/poke.wav");
  }

  const handlePointerDown = useCallback(
    (event: ThreeEvent<PointerEvent>) => {
      if (event.nativeEvent.button !== 0) return;

      let current = event.object;
      let agentName: string | null = null;

      while (current) {
        if (current.name.startsWith("agent-")) {
          agentName = current.name;
          break;
        }
        current = current.parent as typeof current;
      }

      if (agentName) {
        const id = agentName.replace("agent-", "");
        useEngineStore.getState().selectAgent({ id });
        if (pokeAudioRef.current && !useChatPanelStore.getState().soundsMuted) {
          pokeAudioRef.current.currentTime = 0;
          pokeAudioRef.current.play().catch(() => {});
        }
        // On mobile, tapping the lobster toggles the chat panel
        if (window.innerWidth < 1024) {
          window.dispatchEvent(new CustomEvent("agent-tapped"));
        }
      }
    },
    [],
  );

  const handleClick = useCallback(
    (event: ThreeEvent<MouseEvent>) => {
      let current = event.object;
      while (current) {
        if (current.name.startsWith("agent-")) return;
        current = current.parent as typeof current;
      }
      if (event.object.name === "ocean-floor") {
        useEngineStore.getState().selectAgent({ id: null });
      }
    },
    [],
  );

  return {
    handleClick,
    handlePointerDown,
  };
}
